import { sendHeartbeat } from '@/api/requests';
import { TUserRole } from '@/types';

export class THeartbeatService {
  intervalId: NodeJS.Timeout | null = null;

  startHeartbeatUpdates(gameId: number, role: TUserRole) {
    this.intervalId = setInterval(() => {
      sendHeartbeat(gameId, role);
    }, 5000);
  }

  stopHeartbeatUpdates() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
